import { useTranslation } from "@opendash/i18n";
import { Checkbox, Form } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { SelectParseFieldFor } from "../../../../..";
import { PathContext } from "../../../../../context/PathContext";

type Props = {
  field: SelectParseFieldFor<"OD3_Source">;
};

export const OD3_SourceConfig = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Form.Item
      name={[...path, "onlyChildren"]}
      valuePropName="checked"
      label={t("maintenance:ticket.creation.config.form.field.onlyChildren")}
    >
      <Checkbox />
    </Form.Item>
  );
});
